import React from 'react';
import PropTypes from 'prop-types';
import ASocialMedia from '../../atoms/_atoms.social-media';
import { SOCIAL_MEDIA_CONFIG } from './social-media.config';

export default function MSocialMedia({ type, className }) {
	const icons = SOCIAL_MEDIA_CONFIG.map((icon) => {
		return (
			<ASocialMedia
				key={icon.alt}
				img={icon.img[type]}
				alt={icon.alt}
				href={icon.href}
			/>
		);
	});

	return (
		<article className={`m-social-media-list ${className}`}>
			{icons}
		</article>
	);
}

MSocialMedia.propTypes = {
	type: PropTypes.string,
	className: PropTypes.string,
};

MSocialMedia.defaultProps = {
	type: 'color',
	className: '',
};




// WEBPACK FOOTER //
// ./src/components/molecules/social-media/_molecules.social-media.js